/**
 * csair app webview 橡皮筋效果开关
 * @param {bool} [close=true]
 */
export default function iosWebViewRebound(close) {
    close = close || true;
    try {
        if (window.CSNativeObject.getOSType() === 'iPhone') {
            window.CSNativeObject.configWebView(JSON.stringify({
                bounces: close,
            }));
        }
    }
    catch (error) { }
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/app/appWebViewRebound.js
// module id = null
// module chunks = 